import React, { useState, useEffect, useRef } from 'react';
import * as L from "leaflet";
import AddressAutocomplete from "./AddressAutocomplete";

export default function MapSearchControl({address, onChange}) {
    const [currentAddress, setCurrentAddress] = useState(address);


    useEffect(() => {
        setCurrentAddress(address);
    }, [address]);


    const processAutocompleteResponse = (place) => {
        if (!place) {return;}

        if (checkIfLatLng(place)) {
            const [lat, lng] = place.split(',').map(coord => parseFloat(coord.trim()));

            onChange(lat, lng);
            return;
        }


        if (!place.geometry || !place.geometry.location) {return;}

        let locationData = {
            center: { lat: place.geometry.location.lat(), lng: place.geometry.location.lng() },
            bounds: false
        };

        if (place.geometry.viewport) {
            const ne = place.geometry.viewport.getNorthEast();
            const sw = place.geometry.viewport.getSouthWest();

            locationData.bounds = L.latLngBounds({lat: sw.lat(), lng: sw.lng()}, {lat: ne.lat(), lng: ne.lng()});
        }

        if (place.formatted_address) {
            setCurrentAddress(place.formatted_address);
        }

        const additionalData = {
            formatted_address: place.formatted_address.split(',').map(part => part.trim()),
        }

        onChange(locationData?.center?.lat, locationData?.center?.lng, additionalData);
    };



    const checkIfLatLng = (address) => {
        const latLngRegex = /^(-?(?:[0-8]?\d(?:\.\d+)?|90(?:\.0+)?)),\s*(-?(?:1[0-7]?\d(?:\.\d+)?|180(?:\.0+)?|\d?\d(?:\.\d+)?))$/;
        return latLngRegex.test(address);
    }


    return (
        <div className={'flex-grow-1'}>
            <AddressAutocomplete
                value={currentAddress ? currentAddress : ''}
                onChange={processAutocompleteResponse}
                types={['(regions)']}
                componentRestrictions={{ country: 'uk' }}
                className={'form-control input-onmap'}
            />
        </div>
    );
}